// extracted by mini-css-extract-plugin
export default {"Message":"Messages_Message__LXd6U","messagesCard":"Messages_messagesCard__2uHJY","gridContainer":"Messages_gridContainer__ZL1ML"};